import React from "react";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import TextBox from './Components/TextBox.jsx';
import CheckBox from './Components/CheckBox.jsx';
import { UserProvider } from './../Providers/UserProvider';
import { BaseProvider } from './../Providers/BaseProvider'
import { Routes } from './../Core/Constants'

const reloadRecaptcha = () => {
	const scripts = document.querySelectorAll('script[src^="https://www.google.com/recaptcha/api.js"]');
	scripts.forEach(script => script.remove());

	const badges = document.querySelectorAll('.grecaptcha-badge');
	badges.forEach(badge => {
		if (badge && badge.parentElement) {
			badge.parentElement.remove();
		}
	});

	delete window.grecaptcha;

	if (window.registrationCaptchaSiteKey) {
		const script = document.createElement('script');
		script.src = `https://www.google.com/recaptcha/api.js?render=${window.registrationCaptchaSiteKey}`;
		document.head.appendChild(script);
	}
};

const getCaptchaToken = () => {
	if (!window.registrationCaptchaSiteKey) {
		return Promise.resolve('');
	}

	// Pokud se recaptcha ještě nenačetla po předešlém hard restartu
	if (!window.grecaptcha || !window.grecaptcha.ready) {
		return Promise.reject(new Error('Captcha is not available.'));
	}

	return new Promise((resolve, reject) => {
		window.grecaptcha.ready(() => {
			window.grecaptcha.execute(window.registrationCaptchaSiteKey, { action: 'register' })
				.then((token) => {
					if (!token) {
						reject(new Error('Captcha token is empty (null returned).'));
						return;
					}

					resolve(token);
				})
				.catch(reject);
		});
	});
};

const RegistrationForm = ({ onSuccess }) => {
	var T = window.Texts.registration;
	return (

		<Formik
			initialValues={{
				email: '',
				password: '',
				confirmPassword: '',
				dontSendNews: false,
				captchaToken: '',
				notes: ''
			}}
			validationSchema={Yup.object({
				email: Yup.string()
					.email(T.wrongEmail)
					.required('Required'),
				password: Yup.string()
					.min(8, T.passwordMinLength)
					.required('Required'),
				/*	notes: Yup.string()
						.max(250, 'Maximální délka poznámky je 250 znaků'),*/
				confirmPassword: Yup.string()
					.oneOf(
						[Yup.ref('password')], T.passwordsNotMatch,
					)
					.required('Required')
			})}
			onSubmit={(values, actions) => {
				actions.setFieldError('general', undefined);
				getCaptchaToken()
					.then((captchaToken) => {
						const payload = {
							...values,
							captchaToken,
							gdprConsent: true,
							sendNews: !values.dontSendNews
						};

						UserProvider.register(payload, (data) => {
							actions.setSubmitting(false);
							onSuccess();
						},
							(error) => {
								reloadRecaptcha();
								BaseProvider.applyServerFormValidation(actions, error);
								actions.setSubmitting(false);
							}
						);
					})
					.catch(() => {
						reloadRecaptcha();
						actions.setFieldError('general', T.recaptchaErrorMsg);
						actions.setSubmitting(false);
					});
			}} >
			{(props) => (
				<Form className="reg-form-validate" >
					<div>
						{props.errors.general ?
							<div>
								<p className="missing-entry">
									<strong>{props.errors.general}</strong>
								</p>
							</div> : null}
						<div className="box form-box ">
							<div className="prow form">
								<div className="pcol form-group input-5">
									<TextBox label={T.email} name="email" required="true" type="text" />
								</div>
							</div>
							<div className="prow form">
								<div className="pcol form-group input-5">
									<TextBox label={T.password} name="password" required="true" type="password" />
								</div>
								<div className="pcol form-group input-5">
									<TextBox label={T.passwordConfirm} name="confirmPassword" required=" true" type="password" />
								</div>
							</div>
							<div className="form-group">
								<label>{T.gdprText}</label>
								<ul className="Registration-option">
									<li>
										<CheckBox className="" name="dontSendNews">
											<>
												{T.dontSendNews}
											</>
										</CheckBox>
									</li>
								</ul>
							</div>
							<input type="hidden" name="notes" id="notes" value="" />

							<button type="submit" className="btn btn50 iconed icon-continue"><span>{T.doRegister}</span></button>
						</div>
					</div>
				</Form>
			)}
		</Formik>
	);
}
export default RegistrationForm;
